/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type BrokerProfileResponseDtoFullNameWithTitles = { [key: string]: unknown } | null;
